import { render } from "./PageNotFound.vue?vue&type=template&id=7fb9c252&class=bg-volkert-blue"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=7fb9c252&lang=css"

import exportComponent from "C:\\Users\\benny\\Documents\\Programmieren\\Vue\\cellCalculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__